<template>
  <Layout>
    <div class="row" v-if="userData.permissions['others'] == 1">
      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="media-body">
                <p class="text-muted fw-medium mb-2">SMS Balance</p>
                <h4 class="mb-0">{{ commas(sms_balance) }}</h4>
              </div>
              <div
                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
              >
                <span class="avatar-title"
                  ><i class="mdi mdi-message-bulleted font-size-24"></i
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="media-body">
                <p class="text-muted fw-medium mb-2">SMS Sent</p>
                <h4 class="mb-0">{{ commas(studentmessages) }}</h4>
              </div>
              <div
                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
              >
                <span class="avatar-title"
                  ><i class="mdi mdi-telegram font-size-24"></i
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="media-body">
                <p class="text-muted fw-medium mb-2">SMS to Parents</p>
                <h4 class="mb-0">
                  {{ commas(studentmessages + staffmessages) }}
                </h4>
              </div>
              <div
                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
              >
                <span class="avatar-title"
                  ><i class="mdi mdi-seat-individual-suite font-size-24"></i
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="media-body">
                <p class="text-muted fw-medium mb-2">SMS to Staff</p>
                <h4 class="mb-0">{{ commas(staffmessages) }}</h4>
              </div>
              <div
                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
              >
                <span class="avatar-title"
                  ><i class="mdi mdi-message-processing font-size-24"></i
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card shadow-sm">
        <div class="card-body p-2">
          <b-tabs pills vertical nav-class="p-0" content-class="text-dark">
            <b-tab active class="border-0">
              <template v-slot:title>SMS to Parent</template>
              <div class="card p-0">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <form @submit.prevent="addPatient">
                        <div class="row">
                          <div class="col-md-9 pe-0">
                            <label>Parents</label>
                            <v-select
                              :options="students"
                              placeholder="Select a Parent"
                              v-model="student"
                              label="name"
                              :reduce="(student) => student.student_id"
                            ></v-select>
                          </div>
                          <div class="col-md-3 mt-4 ps-0">
                            <b-button
                              type="submit"
                              :disabled="sms_balance <= 0"
                              class="btn ms-1 w-100"
                              variant="primary"
                              ><i class="fas fa-plus-circle"></i
                            ></b-button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-md-9 p-3 shadow-lg">
                      <form @submit.prevent="sendtoPatient">
                        <div class="row">
                          <span
                            class="col-md-4 rounded-2 p-1"
                            v-for="item in smsstudents"
                            :key="item.id"
                          >
                            <b class="text-black">{{ item.student.name }}</b>
                            &nbsp;
                            <small>{{ item.student.telephone }}</small> &nbsp;
                            <b-button
                              @click="removePatient(item.id, item.student.name)"
                              type="button"
                              class="btn-sm btn rounded-3 py-0 px-1"
                              variant="danger"
                              v-b-modal.delete
                            >
                              <i class="mdi mdi-close"></i>
                            </b-button>
                          </span>
                        </div>
                        <label>Message</label>
                        <small class="text-danger"
                          >(Will start with: {{ userData.business }}:)</small
                        >
                        <textarea
                          v-model="msg1"
                          rows="4"
                          @input="CalcSMS1"
                          class="form-control"
                        ></textarea>
                        <small class="text-muted">
                          Characters:
                          <b class="text-primary h5">{{ chars1 }}</b>
                          &nbsp;&nbsp;&nbsp; SMS:
                          <b class="text-primary h5">{{ sms1 }}</b>
                        </small>
                        <b-button
                          type="submit"
                          :disabled="
                            sms_balance <= 0 ||
                              sendbtn1 <= false ||
                              smsstudents.length <= 0
                          "
                          class="btn ms-1 w-100"
                          variant="primary"
                          ><i class="fas fa-check-circle"></i> SEND</b-button
                        >
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab class="border-0">
              <template v-slot:title>SMS to Staff</template>
              <div class="card p-0">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <form @submit.prevent="addStaff">
                        <div class="row">
                          <div class="col-md-9 pe-0">
                            <label>Staff Members</label>
                            <v-select
                              :options="users"
                              placeholder="Select a User"
                              v-model="staff"
                              label="username"
                            ></v-select>
                          </div>
                          <div class="col-md-3 mt-4 ps-0">
                            <b-button
                              type="submit"
                              :disabled="sms_balance <= 0"
                              class="btn ms-1 w-100"
                              variant="primary"
                              ><i class="fas fa-plus-circle"></i
                            ></b-button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-md-9 p-3 shadow-lg">
                      <form @submit.prevent="sendtoStaff">
                        <div class="row">
                          <span
                            class="col-md-4 rounded-2 p-1"
                            v-for="item in smsstaffs"
                            :key="item.id"
                          >
                            <b class="text-black">{{ item.staff.username }}</b>
                            &nbsp;
                            <small>{{ item.staff.contact }}</small> &nbsp;
                            <b-button
                              @click="removeStaff(item.id, item.staff.username)"
                              type="button"
                              class="btn-sm btn rounded-3 py-0 px-1"
                              variant="danger"
                              v-b-modal.delete
                            >
                              <i class="mdi mdi-close"></i>
                            </b-button>
                          </span>
                        </div>
                        <label>Message</label>
                        <small class="text-danger"
                          >(Will start with: {{ userData.business }}:)</small
                        >
                        <textarea
                          v-model="msg2"
                          rows="4"
                          @input="CalcSMS2"
                          class="form-control"
                        ></textarea>
                        <small class="text-muted">
                          Characters:
                          <b class="text-primary h5">{{ chars2 }}</b>
                          &nbsp;&nbsp;&nbsp; SMS:
                          <b class="text-primary h5">{{ sms2 }}</b>
                        </small>
                        <b-button
                          type="submit"
                          :disabled="
                            sms_balance <= 0 ||
                              sendbtn2 <= false ||
                              smsstaffs.length <= 0
                          "
                          class="btn ms-1 w-100"
                          variant="primary"
                          ><i class="fas fa-check-circle"></i> SEND</b-button
                        >
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>

      <b-modal
        id="delete-smsstudent"
        centered
        title="Delete student"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeSmsPatient">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Student:
          <b>{{ studentname }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-smsstudent')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-smsstaff"
        centered
        title="Delete Staff Member"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeSmsStaff">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Staff Member :
          <b>{{ staffname }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-smsstaff')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { studentMethods, studentComputed } from "@/state/helpers";
import { userMethods, userComputed } from "@/state/helpers";
export default {
  page: {
    title: "SMS Center",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      sms_balance: 0,
      studentmessages: 0,
      staffmessages: 0,
      student: [],
      smsstudents: [],
      studentname: "",
      id: "",
      staff: [],
      smsstaffs: [],
      staffname: "",
      staffid: "",
      chars1: 0,
      sms1: 0,
      msg1: "",
      sendbtn1: true,
      chars2: 0,
      sms2: 0,
      msg2: "",
      sendbtn2: true,
    };
  },
  computed: {
    ...studentComputed,
    ...userComputed,
    Items() {
      return this.student.map((d) => ({ name: d.name }));
    },
    Cart() {
      return this.smsstudents.map((d) => ({
        id: d.id,
        student_id: d.student.student_id,
        name: d.student.name,
        telephone: d.student.telephone,
      }));
    },
    StaffCart() {
      return this.smsstaffs.map((d) => ({
        id: d.id,
        staff_id: d.staff_id,
        username: d.staff.username,
        contact: d.staff.contact,
      }));
    },
  },
  mounted() {
    this.fetchPatients();
    this.fetchSMSPatients();
    this.fetchSMSStaffs();
    this.fetchUsers();
    this.showSmsanalysis();
  },
  methods: {
    ...studentMethods,
    ...userMethods,
    CalcSMS1() {
      this.chars1 = this.msg1.length;
      this.sms1 = Math.ceil(this.chars1 / 160) * this.smsstudents.length;
      if (this.sms_balance < this.sms1) {
        this.sendbtn1 = false;
      } else {
        this.sendbtn1 = true;
      }
    },
    CalcSMS2() {
      this.chars2 = this.msg2.length;
      this.sms2 = Math.ceil(this.chars2 / 160) * this.smsstaffs.length;
      if (this.sms_balance < this.sms2) {
        this.sendbtn2 = false;
      } else {
        this.sendbtn2 = true;
      }
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async addPatient() {
      this.CalcSMS1();
      let formData = new FormData();
      formData.append("student", this.student);
      let url = "/addsmsstudent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.student = "";
          this.fetchSMSPatients();
          this.$toast.success(response.data.message);
        }
      });
    },
    async fetchSMSPatients() {
      let url = "/smsstudents";
      await axios.get(url).then((response) => {
        this.smsstudents = response.data.students;
      });
    },
    removePatient(id, name) {
      this.id = id;
      this.studentname = name;
      this.$bvModal.show("delete-smsstudent");
    },
    async removeSmsPatient() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesmsstudent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSMSPatients();
          this.$bvModal.hide("delete-smsstudent");
        }
      });
    },
    async sendtoPatient() {
      let obj = { student: this.Cart, message: this.msg1, sms: this.sms1 };
      let url = "/sendtostudent";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.showSmsanalysis();
          this.fetchSMSPatients();
          this.msg1 = "";
          this.chars1 = "";
          this.sms1 = "";
          this.$toast.success(response.data.message);
        }
      });
    },

    async addStaff() {
      this.CalcSMS2();
      let formData = new FormData();
      formData.append("staff", this.staff.id);

      let url = "/addsmsstaff";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.staff = "";
          this.fetchSMSStaffs();
          this.$toast.success(response.data.message);
        }
      });
    },

    async fetchSMSStaffs() {
      let url = "/smsstaffs";
      await axios.get(url).then((response) => {
        this.smsstaffs = response.data.staffs;
      });
    },
    removeStaff(id, name) {
      this.id = id;
      this.staffname = name;
      this.$bvModal.show("delete-smsstaff");
    },
    async removeSmsStaff() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesmsstaff";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSMSStaffs();
          this.$bvModal.hide("delete-smsstaff");
        }
      });
    },
    async sendtoStaff() {
      let obj = { staff: this.StaffCart, message: this.msg2, sms: this.sms2 };
      let url = "/sendtostaff";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.showSmsanalysis();
          this.fetchSMSStaffs();
          this.msg2 = "";
          this.chars2 = "";
          this.sms2 = "";
          this.$toast.success(response.data.message);
        }
      });
    },

    async showSmsanalysis() {
      let url = "/smsanalysis";
      await axios.get(url).then((response) => {
        this.sms_balance = response.data.sms_balance;
        this.studentmessages = response.data.studentmessages;
        this.staffmessages = response.data.staffmessages;
      });
    },
  },
};
</script>
